/**
 * モバイル選択器の機能
 */

document.addEventListener('DOMContentLoaded', function() {
  const mobileSelects = document.querySelectorAll('.option-select');
  
  // 発送予定日計算関数
  // 共通エンジン `window.businessDayCalculator` に委譲する。
  // 商品の `printhub.delivery_calc_type`（営業日/暦日）、祝日、全商品休業日、締切時間を
  // すべて考慮して計算される。
  function calculateDeliveryDate(deliveryText) {
    const formatDate = function(d) {
      return d.toLocaleDateString('ja-JP', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).replace(/\//g, '/');
    };

    if (window.businessDayCalculator && window.businessDayCalculator.loaded) {
      try {
        const calcType = window.productDeliveryCalcType || 'business_days';
        const dr = window.businessDayCalculator.calculateDeliveryDate(deliveryText, 0, { calcType });
        if (dr && dr.date) {
          return formatDate(dr.date);
        }
      } catch (e) {
        console.warn('[mobile-selector calculateDeliveryDate] Failed:', e);
      }
    }

    // フォールバック（共通エンジン未ロード時のみ）: 土日スキップのみの簡易計算
    let businessDays = 0;
    const match = typeof deliveryText === 'string' ? deliveryText.match(/(\d+)/) : null;
    if (match) {
      businessDays = parseInt(match[1], 10);
    } else if (typeof deliveryText === 'number') {
      businessDays = deliveryText;
    }

    const currentDate = new Date();
    let count = 0;
    while (count < businessDays) {
      currentDate.setDate(currentDate.getDate() + 1);
      if (currentDate.getDay() !== 0 && currentDate.getDay() !== 6) {
        count++;
      }
    }
    return formatDate(currentDate);
  }

  /**
   * 冊子商品（本文紙質ベース）かどうかを判定する。
   * 「本文紙質」Shopify オプションがある場合、またはモノクロ統合モードの場合を冊子扱い。
   * 冊子商品では `用紙` セレクタを「本文紙質」として扱い、印刷色数は非表示にする。
   */
  function isBookletProduct() {
    const shopifyOptions = (window.productData && window.productData.shopify_options) || [];
    const hasBodyPaperOption = shopifyOptions.some(o => o && o.name === '本文紙質');
    const isMonochromeUnified = !!(window.productData && window.productData.isMonochromeUnifiedMode);
    return hasBodyPaperOption || isMonochromeUnified;
  }

  /**
   * モバイルセレクタの変更を currentSelection に反映する
   *
   * PC のセレクタは DOM 上は常に存在する（ビューポートで非表示にしているだけ）ため、
   * `document.getElementById('quantity-input')` の有無で判定すると、モバイル操作時でも
   * 「PC セレクタあり」と判定されてしまい、モバイルの変更が currentSelection に反映されない。
   * 本関数は change イベントから明示的に呼び出し、ユーザ操作を確実に同期する。
   */
  function syncMobileSelectToCurrentSelection(selectEl) {
    if (!window.priceCalculator || typeof window.priceCalculator.updateSelection !== 'function') return;
    if (!selectEl || !selectEl.id) return;

    const value = selectEl.value;
    const updates = {};

    switch (selectEl.id) {
      case 'mobile-quantity-select': {
        const qty = parseInt(value, 10);
        if (!isNaN(qty) && qty > 0) updates.quantity = qty;
        break;
      }
      case 'mobile-delivery-select':
        if (value) updates.delivery = value;
        break;
      case 'mobile-paper-select':
        if (value) {
          // 冊子商品ではモバイルの「用紙」セレクタは本文紙質を指す。
          // Booklet モジュールが bodyPaper を基準に価格マトリックスを切り替えるため、
          // paper ではなく bodyPaper を更新する（selectBodyPaper 側でも更新されるが冗長に保険）。
          if (isBookletProduct()) {
            updates.bodyPaper = value;
          } else {
            updates.paper = value;
          }
        }
        break;
      case 'mobile-print-select':
        if (value !== undefined && value !== null) updates.printColor = value;
        break;
      case 'mobile-page-range-select':
      case 'mobile-page-count-select':
        // ページ範囲/ページ数は専用ハンドラ（window.selectPageRange / window.selectPageCount）が
        // currentSelection とバリアントのロードまで一貫して処理するため、ここでは何もしない。
        return;
      default:
        return;
    }

    if (Object.keys(updates).length > 0) {
      window.priceCalculator.updateSelection(updates);
    }
  }

  // モバイル価格計算関数
  // 前提: currentSelection はすでに最新状態（change イベントで同期済み）であること。
  // 本関数は currentSelection を読んで UI を更新するだけに専念する。
  function calculateMobilePrice() {
    if (!window.priceCalculator) {
      return;
    }

    const currentSelection = window.priceCalculator.currentSelection;
    const quantity = currentSelection.quantity;
    const delivery = currentSelection.delivery;
    const paper = currentSelection.paper;
    const printType = currentSelection.printColor;

    const result = window.priceCalculator.calculatePrice();
    
    if (result) {
      // 料金明細を更新
      const productPrice = result.subtotal;
      const optionPrice = result.optionAdjustment || 0;
      const totalPrice = result.total;
      
      document.getElementById('mobile-sidebar-product-price').textContent = Math.round(productPrice).toLocaleString();
      document.getElementById('mobile-sidebar-option-price').textContent = Math.round(optionPrice).toLocaleString();
      document.getElementById('mobile-sidebar-total-price').textContent = Math.round(totalPrice).toLocaleString();
      
      // 注文情報サマリーを更新
      document.getElementById('mobile-footer-quantity').textContent = `${quantity} 部`;
      
      // 印刷方法情報を取得
      let printMethod = 'オンデマンド'; // デフォルト
      if (window.productGroupInfo && window.productGroupInfo.currentPrintType) {
        printMethod = window.productGroupInfo.currentPrintType;
      }
      // 印刷色数が未選択（冊子/モノクロ統合モードなど printColor 選択肢がない商品）の場合は
      // 印刷方法のみを表示し、「/ null」のような無効な表記を避ける。
      // モノクロ統合モードでは「モノクロ」表記を付与して印刷色を明示する。
      const isMonochromeUnified = !!(window.productData && window.productData.isMonochromeUnifiedMode);
      const hasValidPrintType = printType && printType !== 'null' && String(printType).trim() !== '';
      let printTypeLabel;
      if (hasValidPrintType) {
        printTypeLabel = `${printMethod} / ${printType}`;
      } else if (isMonochromeUnified) {
        printTypeLabel = `${printMethod} / モノクロ`;
      } else {
        printTypeLabel = printMethod;
      }
      document.getElementById('mobile-footer-print-type').textContent = printTypeLabel;
      
      // 発送予定日を計算
      document.getElementById('mobile-footer-delivery').textContent = calculateDeliveryDate(delivery);
    }
  }
  
  // 選択変更時の価格更新
  // ユーザー操作によるモバイルセレクタの変更は currentSelection に即時反映してから再計算する。
  mobileSelects.forEach(select => {
    select.addEventListener('change', function(e) {
      syncMobileSelectToCurrentSelection(e.target);
      setTimeout(calculateMobilePrice, 100);
    });
  });
  
  // ✅ モバイルカート追加機能は cart-handler.js で統一的に処理されています
  // このファイルでは価格計算とセレクター更新のみを担当します
  
  // 文字列正規化関数（全角/半角、括弧の統一）
  function normalizeString(str) {
    if (!str || typeof str !== 'string') return str;
    return str
      .replace(/（/g, '(')
      .replace(/）/g, ')')
      .replace(/／/g, '/')
      .replace(/　/g, ' ')
      .trim();
  }

  // モバイルセレクターを実際のデータで更新
  window.getAvailablePrintColorsForPaper = function(paper) {
    // 【リファクタリング】新しいモジュールで構築されたavailableVariantCombinationsを使用
    const combinations = window.availableVariantCombinations || window.productData?.availableVariantCombinations;
    
    if (combinations && combinations.byPaper && combinations.byPaper[paper]) {
      // 全バリアントベースのマッピングを使用（全てのオプションが表示される）
      return combinations.byPaper[paper];
    }
    
    // フォールバック: 全バリアントから直接抽出
    const allVariants = window.productData?.variants || [];
    const shopifyOptions = window.productData?.shopify_options || [];
    
    if (window.extractConditionsFromVariants && allVariants.length > 0) {
      const extracted = window.extractConditionsFromVariants(allVariants, shopifyOptions);
      return extracted.byPaper[paper] || [];
    }
    
    // 最終フォールバック: Shopifyオプションから取得
    if (window.productData && window.productData.shopify_options) {
      const colorOpt = window.productData.shopify_options.find(o => o.name === '印刷色数');
      if (colorOpt && colorOpt.values && colorOpt.values.length > 0) {
        return colorOpt.values;
      }
    }
    
    return [];
  };
  
  window.updateMobilePrintColorSelector = function(selectedPaper) {
    const printColors = window.getAvailablePrintColorsForPaper(selectedPaper);

    const mobilePrintSelect = document.getElementById('mobile-print-select');
    if (mobilePrintSelect && printColors.length > 0) {
      let currentValue = window.priceCalculator ? window.priceCalculator.currentSelection.printColor : '';
      if (!currentValue || !printColors.includes(currentValue)) {
        currentValue = mobilePrintSelect.value;
      }

      mobilePrintSelect.innerHTML = '';

      printColors.forEach(color => {
        const option = document.createElement('option');
        option.value = color;
        option.textContent = color;
        if (color === currentValue) option.selected = true;
        mobilePrintSelect.appendChild(option);
      });

      if (!printColors.includes(currentValue)) {
        mobilePrintSelect.value = printColors[0];
        if (window.priceCalculator) {
          window.priceCalculator.updateSelection({ printColor: printColors[0] });
        }
      }

      // 印刷色数の変更に連動して色タイプセレクターを更新
      window.updateMobileColorTypeSelector(mobilePrintSelect.value);
    }
  };

  /**
   * モバイル色タイプセレクターを更新
   * @param {string} printColor - 印刷色数
   */
  window.updateMobileColorTypeSelector = function(printColor) {
    const colorTypeGroup = document.getElementById('mobile-color-type-group');
    const colorTypeContainer = document.getElementById('mobile-color-type-container');

    if (!colorTypeGroup || !colorTypeContainer) {
      return;
    }

    // ColorTypeSelectorから色設定を取得
    const colorConfig = window.ColorTypeSelector && window.ColorTypeSelector.getColorsForPrintColor
      ? window.ColorTypeSelector.getColorsForPrintColor(printColor)
      : null;

    // 設定がない場合は非表示（選択も表示も不要）
    if (!colorConfig) {
      colorTypeGroup.style.display = 'none';
      // 選択をクリア
      window.colorTypeSelection = { front: null, back: null };
      updateMobileFooterColorType();
      return;
    }

    // 色選択UIを生成
    let html = '';
    const sides = colorConfig.sides;

    // 表面の色タイプ（選択可能または固定色）
    if (colorConfig.frontEnabled) {
      if (colorConfig.frontSelectable) {
        // 選択可能な場合はボタンUI
        html += generateMobileColorSection('front', '表面', sides.front);
      } else if (sides.front && sides.front.fixed_color) {
        // 固定色の場合は表示のみ
        html += generateMobileFixedColorDisplay('front', '表面', sides.front.fixed_color);
      }
    }

    // 裏面の色タイプ（選択可能または固定色）
    if (colorConfig.backEnabled) {
      if (colorConfig.backSelectable) {
        // 選択可能な場合はボタンUI
        html += generateMobileColorSection('back', '裏面', sides.back);
      } else if (sides.back && sides.back.fixed_color) {
        // 固定色の場合は表示のみ
        html += generateMobileFixedColorDisplay('back', '裏面', sides.back.fixed_color);
      }
    }

    // 裏面が無効な場合は選択をクリア
    if (!colorConfig.backEnabled) {
      if (window.colorTypeSelection) {
        window.colorTypeSelection.back = null;
      }
    }

    colorTypeContainer.innerHTML = html;
    colorTypeGroup.style.display = html ? 'block' : 'none';

    // 固定色の場合はデフォルト選択を設定
    setMobileFixedColorDefaults(colorConfig);

    // 現在の選択状態を反映
    applyMobileColorSelection();

    // イベントリスナーを設定（選択可能なボタンのみ）
    setupMobileColorEvents(colorTypeContainer);

    // フッターも更新
    updateMobileFooterColorType();
  };

  /**
   * 固定色のデフォルト選択を設定
   */
  function setMobileFixedColorDefaults(colorConfig) {
    if (!window.colorTypeSelection) {
      window.colorTypeSelection = { front: null, back: null };
    }

    const sides = colorConfig.sides;

    // 表面が固定色の場合
    if (colorConfig.frontEnabled && !colorConfig.frontSelectable && sides.front && sides.front.fixed_color) {
      window.colorTypeSelection.front = {
        id: sides.front.fixed_color.id,
        name: sides.front.fixed_color.name,
        hex: sides.front.fixed_color.hex
      };
    }

    // 裏面が固定色の場合
    if (colorConfig.backEnabled && !colorConfig.backSelectable && sides.back && sides.back.fixed_color) {
      window.colorTypeSelection.back = {
        id: sides.back.fixed_color.id,
        name: sides.back.fixed_color.name,
        hex: sides.back.fixed_color.hex
      };
    }
  }

  /**
   * モバイル用固定色表示HTMLを生成（選択不可）
   */
  function generateMobileFixedColorDisplay(side, label, fixedColor) {
    if (!fixedColor) return '';

    const isCmyk = fixedColor.id === 'cmyk';
    const dotStyle = isCmyk
      ? 'background: conic-gradient(#00bcd4 0deg 90deg, #e91e63 90deg 180deg, #ffeb3b 180deg 270deg, #1a1a1a 270deg 360deg);'
      : `background-color: ${fixedColor.hex || '#999'};`;

    return `
      <div class="mobile-color-section mobile-color-fixed" data-side="${side}">
        <div class="mobile-color-section-label">${label}</div>
        <div class="mobile-color-fixed-display">
          <span class="mobile-color-dot" style="${dotStyle}"></span>
          <span class="mobile-color-name">${fixedColor.name}</span>
        </div>
      </div>`;
  }

  /**
   * モバイル用色セクションHTMLを生成
   */
  function generateMobileColorSection(side, label, sideConfig) {
    if (!sideConfig || !sideConfig.available_colors || sideConfig.available_colors.length === 0) {
      return '';
    }

    let html = `<div class="mobile-color-section" data-side="${side}">`;
    html += `<div class="mobile-color-section-label">${label}</div>`;
    html += '<div class="mobile-color-buttons">';

    sideConfig.available_colors.forEach(color => {
      const isDefault = sideConfig.default_color === color.id;
      const isCmyk = color.id === 'cmyk';
      const dotStyle = isCmyk
        ? 'background: conic-gradient(#00bcd4 0deg 90deg, #e91e63 90deg 180deg, #ffeb3b 180deg 270deg, #1a1a1a 270deg 360deg);'
        : `background-color: ${color.hex || '#999'};`;

      html += `
        <button type="button"
                class="mobile-color-btn ${isDefault ? 'default' : ''}"
                data-side="${side}"
                data-color-id="${color.id}"
                data-color-name="${color.name}"
                data-color-hex="${color.hex || ''}">
          <span class="mobile-color-dot" style="${dotStyle}"></span>
          <span class="mobile-color-name">${color.name}</span>
        </button>`;
    });

    html += '</div></div>';
    return html;
  }

  /**
   * 現在の選択状態をモバイルUIに反映
   */
  function applyMobileColorSelection() {
    const selection = window.colorTypeSelection || { front: null, back: null };

    ['front', 'back'].forEach(side => {
      const buttons = document.querySelectorAll(`.mobile-color-btn[data-side="${side}"]`);
      buttons.forEach(btn => {
        const colorId = btn.dataset.colorId;
        const isSelected = selection[side] && selection[side].id === colorId;
        btn.classList.toggle('selected', isSelected);
      });

      // 選択がない場合はデフォルトを選択
      if (!selection[side]) {
        const defaultBtn = document.querySelector(`.mobile-color-btn[data-side="${side}"].default`);
        if (defaultBtn) {
          defaultBtn.classList.add('selected');
          // グローバル選択状態を更新
          if (!window.colorTypeSelection) {
            window.colorTypeSelection = { front: null, back: null };
          }
          window.colorTypeSelection[side] = {
            id: defaultBtn.dataset.colorId,
            name: defaultBtn.dataset.colorName,
            hex: defaultBtn.dataset.colorHex
          };
        }
      }
    });
  }

  /**
   * モバイル色選択のイベントリスナーを設定
   */
  function setupMobileColorEvents(container) {
    const buttons = container.querySelectorAll('.mobile-color-btn');

    buttons.forEach(btn => {
      btn.addEventListener('click', function() {
        const side = this.dataset.side;
        const colorId = this.dataset.colorId;
        const colorName = this.dataset.colorName;
        const colorHex = this.dataset.colorHex;

        // 同じサイドの他のボタンの選択を解除
        document.querySelectorAll(`.mobile-color-btn[data-side="${side}"]`).forEach(b => {
          b.classList.remove('selected');
        });

        // このボタンを選択
        this.classList.add('selected');

        // グローバル選択状態を更新
        if (!window.colorTypeSelection) {
          window.colorTypeSelection = { front: null, back: null };
        }
        window.colorTypeSelection[side] = {
          id: colorId,
          name: colorName,
          hex: colorHex
        };

        // イベント発火
        const event = new CustomEvent('colorTypeChanged', {
          detail: {
            side: side,
            color: window.colorTypeSelection[side],
            selection: window.colorTypeSelection
          }
        });
        document.dispatchEvent(event);

        // フッターの印刷色表示を更新
        updateMobileFooterColorType();

      });
    });
  }

  /**
   * モバイルフッターの印刷色表示を更新
   */
  function updateMobileFooterColorType() {
    const colorTypeRow = document.getElementById('mobile-footer-color-type-row');
    const colorTypeEl = document.getElementById('mobile-footer-color-type');

    if (!colorTypeRow || !colorTypeEl) return;

    const selection = window.colorTypeSelection;
    if (!selection || (!selection.front && !selection.back)) {
      colorTypeRow.style.display = 'none';
      return;
    }

    let displayParts = [];
    if (selection.front) {
      displayParts.push(`表: ${selection.front.name}`);
    }
    if (selection.back) {
      displayParts.push(`裏: ${selection.back.name}`);
    }

    if (displayParts.length > 0) {
      colorTypeEl.textContent = displayParts.join(' / ');
      colorTypeRow.style.display = '';
    } else {
      colorTypeRow.style.display = 'none';
    }
  }

  // モバイル色タイプセレクターのスタイルを追加
  function addMobileColorTypeStyles() {
    if (document.getElementById('mobile-color-type-styles')) return;

    const style = document.createElement('style');
    style.id = 'mobile-color-type-styles';
    style.textContent = `
      .mobile-color-type-container {
        padding: 8px 0;
      }
      .mobile-color-section {
        margin-bottom: 12px;
      }
      .mobile-color-section:last-child {
        margin-bottom: 0;
      }
      .mobile-color-section-label {
        font-size: 12px;
        font-weight: 600;
        color: #666;
        margin-bottom: 8px;
      }
      .mobile-color-buttons {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
      }
      .mobile-color-btn {
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 8px 12px;
        border: 2px solid #e0e0e0;
        border-radius: 8px;
        background: #fff;
        cursor: pointer;
        transition: all 0.2s ease;
        font-size: 13px;
      }
      .mobile-color-btn:hover {
        border-color: #1565C0;
      }
      .mobile-color-btn.selected {
        border-color: #1565C0;
        background: #e3f2fd;
        color: #1565C0;
        font-weight: 600;
      }
      .mobile-color-dot {
        width: 18px;
        height: 18px;
        border-radius: 50%;
        border: 1px solid rgba(0,0,0,0.2);
        flex-shrink: 0;
      }
      .mobile-color-name {
        white-space: nowrap;
      }
      .mobile-color-fixed-display {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 10px 14px;
        background: #f5f5f5;
        border-radius: 8px;
        font-size: 14px;
        color: #333;
      }
      .mobile-color-fixed .mobile-color-dot {
        width: 20px;
        height: 20px;
      }
    `;
    document.head.appendChild(style);
  }

  // スタイルを初期化
  addMobileColorTypeStyles();
  
  window.initializeMobilePaperAndColorSelectors = function() {
    // price_matrixがなくても、availableVariantCombinationsまたはShopifyオプションがあれば初期化可能
    const hasPriceMatrix = window.productData && window.productData.price_matrix &&
                          (window.productData.price_matrix.variations || window.productData.price_matrix.price_data);
    const hasVariantCombinations = window.availableVariantCombinations &&
                                   Object.keys(window.availableVariantCombinations.byPaper || {}).length > 0;
    const hasShopifyOptions = window.productData && window.productData.shopify_options;

    if (!hasPriceMatrix && !hasVariantCombinations && !hasShopifyOptions) {
      console.log('[MobileSelector] No data available for initialization, skipping');
      return;
    }

    console.log('[MobileSelector] Initializing paper and color selectors');

    const shopifyOptions = (window.productData && window.productData.shopify_options) || [];
    const booklet = isBookletProduct();

    // 冊子/モノクロ統合モードでは「印刷色数」選択肢が存在しないため、該当セクションを非表示にする。
    // 通常商品の場合も明示的に表示を戻しておく（他商品へ遷移した場合のリセット）。
    const printColorGroup = document.getElementById('mobile-print-color-group');
    if (printColorGroup) {
      const hasPrintColorOption = shopifyOptions.some(o => o && o.name === '印刷色数');
      const hideForBooklet = booklet && !hasPrintColorOption;
      const hideForMonochrome = !!(window.productData && window.productData.isMonochromeUnifiedMode);
      printColorGroup.style.display = (hideForBooklet || hideForMonochrome) ? 'none' : '';
    }

    // 用紙リストの取得
    // - 冊子商品: 「本文紙質」Shopify オプションの値を使用（PCの Booklet 本文紙質セレクタと揃える）
    // - 通常商品: 「用紙」Shopify オプションの値を使用
    const papers = new Set();
    const hasPageCountOption = (shopifyOptions.some(opt => opt.name === 'ページ数' || opt.name === 'ページ範囲')) ||
      (window.pageCountOptions && window.pageCountOptions.options);

    if (booklet) {
      const bodyPaperOpt = shopifyOptions.find(o => o && o.name === '本文紙質');
      if (bodyPaperOpt && bodyPaperOpt.values) {
        bodyPaperOpt.values.forEach(v => papers.add(v));
      }
    } else if (shopifyOptions.length > 0) {
      const paperOpt = shopifyOptions.find(o => o && o.name === '用紙');
      if (paperOpt && paperOpt.values) {
        paperOpt.values.forEach(v => papers.add(v));
      }
    }

    // fallback 1: availableVariantCombinationsから用紙を取得（lazy load後に利用可能）
    if (papers.size === 0 && window.availableVariantCombinations && window.availableVariantCombinations.byPaper) {
      Object.keys(window.availableVariantCombinations.byPaper).forEach(paper => {
        if (paper && paper !== '標準') {
          papers.add(paper);
        }
      });
      console.log('[MobileSelector] Extracted papers from availableVariantCombinations:', papers.size);
    }

    // fallback 2: variationsから抽出（Shopifyオプションがない場合のみ）
    // ただし、ページ数/ページ範囲オプションがある場合は、variationCodeはページ範囲の値なので用紙として抽出しない
    if (papers.size === 0 && !hasPageCountOption && window.productData && window.productData.price_matrix && window.productData.price_matrix.variations) {
      const variations = window.productData.price_matrix.variations;
      Object.keys(variations).forEach(varCode => {
        if (varCode === '標準') {
          return;
        }
        if (varCode.includes('_')) {
          const parts = varCode.split('_');
          if (parts.length >= 2) {
            papers.add(parts[parts.length - 1]); // 最後のパーツを用紙とする
          }
        } else {
          papers.add(varCode);
        }
      });
    }

    const papersArray = Array.from(papers).sort();

    const mobilePaperSelect = document.getElementById('mobile-paper-select');
    if (mobilePaperSelect) {
      mobilePaperSelect.innerHTML = '';
      // 冊子商品では bodyPaper を基準にする。
      let currentPaper;
      if (booklet && window.priceCalculator) {
        currentPaper = window.priceCalculator.currentSelection.bodyPaper || papersArray[0];
      } else {
        currentPaper = window.priceCalculator
          ? window.priceCalculator.currentSelection.paper
          : papersArray[0];
      }
      papersArray.forEach(paper => {
        const option = document.createElement('option');
        option.value = paper;
        option.textContent = paper;
        if (paper === currentPaper) option.selected = true;
        mobilePaperSelect.appendChild(option);
      });

      mobilePaperSelect.addEventListener('change', function() {
        const value = this.value;
        if (booklet) {
          // 冊子商品では本文紙質を選択。Booklet モジュールが price_matrix を再ロードする。
          if (typeof window.selectBodyPaper === 'function') {
            window.selectBodyPaper(value);
          } else if (window.priceCalculator) {
            // Booklet 未初期化時のフォールバック
            window.priceCalculator.updateSelection({ bodyPaper: value });
          }
        } else {
          // 通常商品 / ページ範囲+用紙（オンデマンド冊子）は selectPaper でマトリクス切替
          if (typeof window.selectPaper === 'function') {
            window.selectPaper(value);
          } else {
            window.updateMobilePrintColorSelector(value);
          }
        }
        setTimeout(() => {
          window.updateMobileSelectorsFromData();
        }, 50);
      });
    }

    // 印刷色数セレクターの変更イベントを監視
    const mobilePrintSelect = document.getElementById('mobile-print-select');
    if (mobilePrintSelect) {
      mobilePrintSelect.addEventListener('change', function() {
        const newPrintColor = this.value;
        // 印刷色数の選択状態を更新
        if (window.priceCalculator) {
          window.priceCalculator.updateSelection({ printColor: newPrintColor });
        }
        // 色タイプセレクターを更新
        window.updateMobileColorTypeSelector(newPrintColor);
        // 価格再計算
        setTimeout(() => {
          window.updateMobileSelectorsFromData();
        }, 50);
      });
    }

    if (!booklet) {
      const selectedPaper = mobilePaperSelect ? mobilePaperSelect.value : papersArray[0];
      window.updateMobilePrintColorSelector(selectedPaper);
    }
  };

  /**
   * ページ範囲のソート済みリストを取得する。
   * 優先: `window.pageRangeOptions`（Liquid で設定、size > 1 の場合のみ）
   * フォールバック: Shopify オプションの「ページ範囲」values
   */
  function getSortedPageRanges() {
    const shopifyOptions = (window.productData && window.productData.shopify_options) || [];
    let ranges = [];
    if (Array.isArray(window.pageRangeOptions) && window.pageRangeOptions.length > 0) {
      ranges = [...window.pageRangeOptions];
    } else {
      const pageRangeOpt = shopifyOptions.find(o => o && o.name === 'ページ範囲');
      if (pageRangeOpt && Array.isArray(pageRangeOpt.values)) {
        ranges = [...pageRangeOpt.values];
      }
    }
    // 最小ページ数で昇順ソート（PC と同じロジック）
    return ranges.sort((a, b) => {
      const ma = typeof a === 'string' ? a.match(/^(\d+)/) : null;
      const mb = typeof b === 'string' ? b.match(/^(\d+)/) : null;
      const minA = ma ? parseInt(ma[1], 10) : 0;
      const minB = mb ? parseInt(mb[1], 10) : 0;
      return minA - minB;
    });
  }

  /**
   * 指定したページ範囲に対応するページ数リストを取得する。
   * PC の VariantSelectors.getPageCountOptionsForRange に委譲し、無ければ price_data から抽出する。
   */
  function getPageCountsForRange(pageRange) {
    if (window.PriceCalculator &&
        window.PriceCalculator.VariantSelectors &&
        typeof window.PriceCalculator.VariantSelectors.getPageCountOptionsForRange === 'function') {
      try {
        const list = window.PriceCalculator.VariantSelectors.getPageCountOptionsForRange(pageRange);
        if (Array.isArray(list)) return list;
      } catch (e) {
        console.warn('[MobileSelector] getPageCountOptionsForRange failed:', e);
      }
    }
    // フォールバック: price_data から直接抽出
    if (!pageRange) return [];
    const match = String(pageRange).match(/^(\d+)(?:[-〜～](\d+))?(?:P|ページ〜?)?$/);
    if (!match) return [];
    const min = parseInt(match[1], 10);
    const max = match[2] ? parseInt(match[2], 10) : min;
    const priceData = (window.productData && window.productData.price_matrix && window.productData.price_matrix.price_data) || [];
    return [...new Set(
      priceData
        .filter(p => p.page_count !== undefined && p.page_count !== null && p.page_count >= min && p.page_count <= max)
        .map(p => Number(p.page_count))
    )].sort((a, b) => a - b);
  }

  /**
   * モバイルのページ範囲・ページ数セレクタを初期化する（冊子商品のみ対象）。
   * 非冊子商品ではセレクタを非表示にする。
   * 変更時は PC と同じ `window.selectPageRange` / `window.selectPageCount` に委譲し、
   * Booklet モジュールが price_matrix をロードして UI 全体を更新するフローに乗せる。
   */
  window.initializeMobilePageSelectors = function() {
    const pageRangeGroup = document.getElementById('mobile-page-range-group');
    const pageCountGroup = document.getElementById('mobile-page-count-group');
    const pageRangeSelect = document.getElementById('mobile-page-range-select');
    const pageCountSelect = document.getElementById('mobile-page-count-select');

    if (!pageRangeGroup || !pageCountGroup || !pageRangeSelect || !pageCountSelect) return;

    // 冊子商品以外では非表示（他商品への遷移でも確実に隠す）
    if (!isBookletProduct()) {
      pageRangeGroup.style.display = 'none';
      pageCountGroup.style.display = 'none';
      return;
    }

    const sortedRanges = getSortedPageRanges();
    const currentRange = (window.priceCalculator && window.priceCalculator.currentSelection.pageRange) || sortedRanges[0] || '';

    // ページ範囲: 選択肢が2つ以上ある場合のみ表示する（PCと同じ挙動）
    if (sortedRanges.length >= 2) {
      pageRangeGroup.style.display = '';
      pageRangeSelect.innerHTML = '';
      sortedRanges.forEach(range => {
        const option = document.createElement('option');
        option.value = range;
        option.textContent = range;
        if (range === currentRange) option.selected = true;
        pageRangeSelect.appendChild(option);
      });
    } else {
      pageRangeGroup.style.display = 'none';
    }

    // ページ数: ページ範囲に応じたリストから生成
    const pageCounts = getPageCountsForRange(currentRange);
    const currentPageCount = window.priceCalculator && window.priceCalculator.currentSelection.pageCount;

    if (pageCounts.length > 0) {
      pageCountGroup.style.display = '';
      pageCountSelect.innerHTML = '';
      pageCounts.forEach(count => {
        const option = document.createElement('option');
        option.value = String(count);
        option.textContent = count + 'ページ';
        if (Number(count) === Number(currentPageCount)) option.selected = true;
        pageCountSelect.appendChild(option);
      });
    } else {
      pageCountGroup.style.display = 'none';
    }

    // 変更ハンドラを一度だけ登録する（data 属性で重複登録を抑止）
    if (!pageRangeSelect.dataset.mobileHandlerAttached) {
      pageRangeSelect.addEventListener('change', async function() {
        const value = this.value;
        if (!value) return;
        try {
          if (typeof window.selectPageRange === 'function') {
            await window.selectPageRange(value);
          } else if (window.priceCalculator) {
            // フォールバック: 直接 currentSelection を更新
            window.priceCalculator.updateSelection({ pageRange: value });
          }
        } catch (e) {
          console.warn('[MobileSelector] selectPageRange failed:', e);
        }
        // ページ範囲変更後はページ数の選択肢が変わるのでセレクタを再生成し、
        // 部数・納期を更新した後に料金明細を再計算する。
        // （calculatePrice は variant の loadPriceMatrix 完了後に呼ぶ必要があるため、
        //   汎用ハンドラの setTimeout(calculateMobilePrice, 100) では間に合わない。）
        window.initializeMobilePageSelectors();
        window.updateMobileSelectorsFromData();
        calculateMobilePrice();
      });
      pageRangeSelect.dataset.mobileHandlerAttached = 'true';
    }

    if (!pageCountSelect.dataset.mobileHandlerAttached) {
      pageCountSelect.addEventListener('change', async function() {
        const value = this.value;
        if (!value) return;
        try {
          if (typeof window.selectPageCount === 'function') {
            // PC の selectPageCount はラベル（例: "8ページ"）を想定
            await window.selectPageCount(value + 'ページ');
          } else if (window.priceCalculator) {
            window.priceCalculator.updateSelection({ pageCount: Number(value) });
          }
        } catch (e) {
          console.warn('[MobileSelector] selectPageCount failed:', e);
        }
        window.updateMobileSelectorsFromData();
        calculateMobilePrice();
      });
      pageCountSelect.dataset.mobileHandlerAttached = 'true';
    }
  };

  /**
   * PC 側で発生した変更（モーダル経由）をモバイル UI に反映するため、
   * `window.updateUI` をラップして毎回モバイルのセレクタ状態と料金明細を同期する。
   * 多重ラップを避けるためフラグで一度だけ実行する。
   * また再入を防ぐため実行中フラグでガードする（calculateMobilePrice 自体は updateUI を
   * 呼ばないが、将来の変更に備えた保険）。
   */
  function hookUpdateUIForMobileSync() {
    if (window.__mobileUpdateUIHooked) return;
    if (typeof window.updateUI !== 'function') return;
    const original = window.updateUI;
    let syncing = false;
    window.updateUI = function(...args) {
      const result = original.apply(this, args);
      if (syncing) return result;
      syncing = true;
      try {
        // ページ範囲/ページ数は PC 変更（モーダル）時に再描画が必要
        if (typeof window.initializeMobilePageSelectors === 'function') {
          window.initializeMobilePageSelectors();
        }
        // 用紙セレクタ（本文紙質）も PC 変更に追従するため選択状態を合わせる
        syncMobilePaperSelectToCurrentSelection();
        // 部数・納期セレクタと料金明細も PC 変更に追従させる。
        // PC でバリアント切替が発生した場合、モバイル側の価格が 0 のまま残らないようにする。
        if (typeof window.updateMobileSelectorsFromData === 'function') {
          window.updateMobileSelectorsFromData();
        }
        calculateMobilePrice();
      } catch (e) {
        console.warn('[MobileSelector] updateUI hook failed:', e);
      } finally {
        syncing = false;
      }
      return result;
    };
    window.__mobileUpdateUIHooked = true;
  }

  /**
   * モバイル用紙セレクタの選択状態を currentSelection に合わせる（値の再生成は行わない）。
   * PC で本文紙質が切り替わった際に、モバイル側の選択表示が古いままになるのを防ぐ。
   */
  function syncMobilePaperSelectToCurrentSelection() {
    const mobilePaperSelect = document.getElementById('mobile-paper-select');
    if (!mobilePaperSelect || !window.priceCalculator) return;
    const booklet = isBookletProduct();
    const target = booklet
      ? window.priceCalculator.currentSelection.bodyPaper
      : window.priceCalculator.currentSelection.paper;
    if (!target) return;
    const options = Array.from(mobilePaperSelect.options).map(o => o.value);
    if (options.includes(target) && mobilePaperSelect.value !== target) {
      mobilePaperSelect.value = target;
    }
  }

  // 【統一設計】variation_code: 用紙_印刷色 形式
  window.updateMobileSelectorsFromData = function() {
    // priceCalculatorが初期化されていない場合はスキップ
    if (!window.priceCalculator || !window.priceCalculator.currentSelection) {
      console.log('[MobileSelector] priceCalculator not ready, skipping updateMobileSelectorsFromData');
      return;
    }

    // price_matrixが存在しない場合もスキップ
    if (!window.productData || !window.productData.price_matrix || !window.productData.price_matrix.price_data) {
      console.log('[MobileSelector] price_matrix.price_data not available, skipping');
      return;
    }

    const currentPaper = window.priceCalculator.currentSelection.paper || '';
    const currentPrintColor = window.priceCalculator.currentSelection.printColor || '';
    const currentPageCount = window.priceCalculator.currentSelection.pageCount || '';

    const allPriceData = window.productData.price_matrix.price_data || [];
    const booklet = isBookletProduct();

    // 冊子商品では paper/printColor を使った variation_code 構築はできない
    // （Shopify オプションが本文紙質/ページ範囲のため）。
    // Booklet モジュールが選択中バリアントの price_matrix をロード済みなので、
    // 現在ロードされている price_data に含まれる variation_code を動的に採用する。
    let currentVariationCode;
    if (booklet) {
      const variationCodes = [...new Set(allPriceData.map(p => p.variation_code).filter(Boolean))];
      // 優先順: 「本文と同じ」→ 先頭のコード → '標準'
      if (variationCodes.includes('本文と同じ')) {
        currentVariationCode = '本文と同じ';
      } else if (variationCodes.length > 0) {
        currentVariationCode = variationCodes[0];
      } else {
        currentVariationCode = '標準';
      }
    } else if (window.priceCalculator && typeof window.priceCalculator.buildVariationCode === 'function') {
      // 通常商品: buildVariationCodeメソッドを使用（正規化とマッチングロジックを適用）
      currentVariationCode = window.priceCalculator.buildVariationCode(currentPaper, currentPrintColor);
    } else {
      // フォールバック: 従来のロジック
      const sampleVariationCodes = [...new Set(allPriceData.map(p => p.variation_code).filter(v => v && v !== '標準'))];

      const variant1 = [currentPaper, currentPrintColor].filter(p => p && p !== 'null' && p !== '').join('_');
      const variant2 = [currentPrintColor, currentPaper].filter(p => p && p !== 'null' && p !== '').join('_');

      if (sampleVariationCodes.includes(variant1)) {
        currentVariationCode = variant1;
      } else if (sampleVariationCodes.includes(variant2)) {
        currentVariationCode = variant2;
      } else if (variant1) {
        currentVariationCode = variant1;
      } else {
        currentVariationCode = '標準';
      }
    }

    let priceData = allPriceData.filter(p => p.variation_code === currentVariationCode);

    // 冊子商品では variation_code だけでは絞りきれないため、body_paper と page_count で追加フィルタする。
    if (booklet) {
      const selectedBodyPaper = window.priceCalculator.currentSelection.bodyPaper || '';
      const selectedPageCount = window.priceCalculator.currentSelection.pageCount;

      const withBodyPaper = selectedBodyPaper
        ? priceData.filter(p => !p.body_paper || p.body_paper === selectedBodyPaper)
        : priceData;
      const filtered = selectedPageCount
        ? withBodyPaper.filter(p => p.page_count === undefined || p.page_count === null || Number(p.page_count) === Number(selectedPageCount))
        : withBodyPaper;
      if (filtered.length > 0) {
        priceData = filtered;
      }
    }

    if (priceData.length === 0) {
      console.log('[MobileSelector] No price data for variation:', currentVariationCode);
      return;
    }
    
    let availableQuantities = [...new Set(priceData.map(p => p.quantity))].sort((a, b) => a - b);

    // PrintHubで設定された有効部数でフィルタリング
    if (window.enabledQuantities && Array.isArray(window.enabledQuantities) && window.enabledQuantities.length > 0) {
      const enabledQtySet = new Set(window.enabledQuantities.map(q => Number(q)));
      const filteredQuantities = availableQuantities.filter(q => enabledQtySet.has(Number(q)));
      if (filteredQuantities.length > 0) {
        availableQuantities = filteredQuantities;
      } else {
        console.warn('[MobileSelector] enabled_quantities filter resulted in no quantities, showing all');
      }
    }

    const mobileQuantitySelect = document.getElementById('mobile-quantity-select');
    if (mobileQuantitySelect) {
      mobileQuantitySelect.innerHTML = '';
      const currentQuantity = window.priceCalculator ? window.priceCalculator.currentSelection.quantity : 10;
      availableQuantities.forEach(qty => {
        const option = document.createElement('option');
        option.value = qty;
        option.textContent = `${qty}部`;
        if (qty === currentQuantity) option.selected = true;
        mobileQuantitySelect.appendChild(option);
      });
    }
    
    let availableDeliveries = [...new Set(priceData.map(p => p.delivery_time))].filter(d => d);

    // PrintHubで設定された有効納期でフィルタリング
    if (window.enabledDeliveryDays && Array.isArray(window.enabledDeliveryDays) && window.enabledDeliveryDays.length > 0) {
      const enabledSet = new Set(window.enabledDeliveryDays.map(d => Number(d)));
      const filteredDeliveries = availableDeliveries.filter(d => {
        const strD = String(d);
        // 「翌営業日」は1営業日として扱う
        if (strD.includes('翌営業日')) {
          return enabledSet.has(1);
        }
        const match = strD.match(/(\d+)/);
        if (match) {
          return enabledSet.has(Number(match[1]));
        }
        return false;
      });
      if (filteredDeliveries.length > 0) {
        availableDeliveries = filteredDeliveries;
      }
    }

    const deliveryOrder = ['20営業日', '15営業日', '10営業日', '9営業日', '8営業日', '7営業日', '6営業日', '5営業日', '4営業日', '3営業日', '2営業日', '翌営業日', '当日18時', '当日15時', '当日12時', '当日10時', '当日9時', '当日8時', '当日6時'];
    const orderedDeliveries = deliveryOrder.filter(d => availableDeliveries.includes(d));
    // 数値ソート: "10日"が"2日"より後に来るように
    const otherDeliveries = availableDeliveries.filter(d => !deliveryOrder.includes(d)).sort((a, b) => {
      const numA = parseInt(String(a).match(/\d+/)?.[0] || '0', 10);
      const numB = parseInt(String(b).match(/\d+/)?.[0] || '0', 10);
      return numB - numA; // 降順（納期が長い順）
    });
    const sortedDeliveries = [...orderedDeliveries, ...otherDeliveries];
    
    const mobileDeliverySelect = document.getElementById('mobile-delivery-select');
    if (mobileDeliverySelect) {
      mobileDeliverySelect.innerHTML = '';
      // 現在選択中の納期を currentSelection から取得。
      // セレクタが存在する場合は、ユーザーの選択を維持したい。
      const currentDelivery = window.priceCalculator
        ? window.priceCalculator.currentSelection.delivery
        : null;
      // フォールバック: currentSelection.delivery が利用可能なリストにない場合は
      // 優先順の先頭（「4営業日」→なければ最初の利用可能な納期）を既定にする
      const fallbackDelivery = sortedDeliveries.includes('4営業日')
        ? '4営業日'
        : sortedDeliveries[0];
      const effectiveDelivery = sortedDeliveries.includes(currentDelivery)
        ? currentDelivery
        : fallbackDelivery;

      sortedDeliveries.forEach(delivery => {
        const option = document.createElement('option');
        option.value = delivery; // 内部値は元のまま
        option.textContent = window.formatDeliveryLabel ? window.formatDeliveryLabel(delivery) : delivery; // 表示はproductDeliveryCalcTypeに応じて変換
        if (delivery === effectiveDelivery) option.selected = true;
        mobileDeliverySelect.appendChild(option);
      });

      // currentSelection が空や無効値だった場合はフォールバック値で補正する。
      // これにより、以降の価格計算・発送予定日計算が常に有効な値で動作する。
      if (effectiveDelivery && effectiveDelivery !== currentDelivery &&
          window.priceCalculator && typeof window.priceCalculator.updateSelection === 'function') {
        window.priceCalculator.updateSelection({ delivery: effectiveDelivery });
      }
    }
  };
  
  // colorTypeChangedイベントをリスン（PCとの同期）
  document.addEventListener('colorTypeChanged', function(e) {
    // モバイルのUI選択状態を更新
    applyMobileColorSelection();
    // フッターも更新
    updateMobileFooterColorType();
  });

  // 初期価格計算
  // 遅延ロード商品（冊子等）では、priceCalculator/productData が先に用意されても
  // price_matrix.price_data がまだ空のタイミングがある。その状態で calculateMobilePrice を
  // 呼ぶと basePrice=0 になり、料金明細に 0 円が残ってしまう。
  // price_data が空でないこと（または十分に待機したこと）を確認してから初期化する。
  const startedAt = Date.now();
  const waitForCalculator = setInterval(() => {
    if (!window.priceCalculator || !window.productData) return;
    const priceMatrix = window.productData.price_matrix;
    const hasPriceData = priceMatrix && Array.isArray(priceMatrix.price_data) && priceMatrix.price_data.length > 0;
    const waitedLongEnough = Date.now() - startedAt > 3000;
    // price_data が準備できているか、3秒以上待った場合に初期化を走らせる
    if (!hasPriceData && !waitedLongEnough) return;

    clearInterval(waitForCalculator);
    window.initializeMobilePaperAndColorSelectors();
    window.initializeMobilePageSelectors();
    window.updateMobileSelectorsFromData();
    calculateMobilePrice();
    // PC（モーダル等）からの変更をモバイルに反映するため updateUI をフック
    hookUpdateUIForMobileSync();
    // 初期化直後に PC 側で追加の updateUI が走るケース（バリアント切替等）に備え、
    // 少し遅延して再計算して料金明細を確実に反映する。
    setTimeout(() => {
      if (typeof calculateMobilePrice === 'function') calculateMobilePrice();
    }, 300);
  }, 200);

  setTimeout(() => {
    clearInterval(waitForCalculator);
  }, 5000);
});

